import React, { useState, useEffect } from 'react';
import AdminSidebar from './AdminSidebar';

const AdminMainLayout = ({ children }) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [isMenuVisible, setIsMenuVisible] = useState(true);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 100) {
                setIsMenuVisible(false);
            } else {
                setIsMenuVisible(true);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className="flex min-h-screen">
            <AdminSidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
            <div className="flex-1 bg-[#F3ECDE] min-h-screen mt-10">
                <button
                    className={`sm:hidden fixed top-56 left-4 z-50 text-[#12392B] hover:text-[#E6A71A] focus:outline-none transition-opacity duration-300 ${isMenuVisible ? 'opacity-100' : 'opacity-0'
                        }`}
                    onClick={toggleSidebar}
                    aria-label="Open sidebar"
                >
                    <svg
                        className="w-6 h-6"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M4 6h16M4 12h16M4 18h16"
                        />
                    </svg>
                </button>
                <div className={`p-6 transition-all duration-300  ${isSidebarOpen ? 'ml-64 sm:ml-0' : 'ml-0'}`}>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default AdminMainLayout;